import Vue from 'vue'
import Router from 'vue-router'

import index from '@/components/index'
import tour from '@/components/tour/index'
import service from '@/components/service/index'
import userinfo from '@/components/userinfo/index'
import synopsis from '@/components/synopsis/index'


/*子路由*/
import tourchildren from '@/router/tour'
import servicechildren from '@/router/service/'
import userinfochildren from '@/router/userinfo/'
import synopsischildren from '@/router/synopsis/'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '404',
      component: index,
      meta: {
        title: '徐悲鸿纪念馆'
      }
    },
    {
      path: '/index',
      name: 'index',
      component: index,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/synopsis',
      name: 'synopsis',
      redirect: '/synopsis/jng_gk',
      component: synopsis,
      meta: {
        title: '纪念馆概括'
      },
      children: [
        ...synopsischildren
      ]
    },
    {
      path: '/tour',
      name: 'tour',
      redirect: '/tour/online',
      component: tour,
      meta: {
        title: '徐馆导赏'
      },
      children: [
        ...tourchildren
      ]
    },
    {
      path: '/service',
      name: 'service',
      component: service,
      meta: {
        title: '参观服务'
      },
      children: [
        ...servicechildren
      ]
    },
    {
      path: '/userinfo',
      name: 'userinfo',
      redirect: '/userinfo/record',
      component: userinfo,
      meta: {
        title: '个人中心'
      },
      children: [
        ...userinfochildren
      ]
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js